import React from "react";
import { Tooltip } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

import { InfoTrigger } from "./styles";
import { InfoHintProps } from "./types";

const TOUCH_LEAVE_DELAY_MS = 4000;

export const InfoHint: React.FC<InfoHintProps> = ({ title, label, testId }) => (
  <Tooltip
    title={title}
    arrow
    enterTouchDelay={0}
    leaveTouchDelay={TOUCH_LEAVE_DELAY_MS}
  >
    {/* The empty title stops a parent's native title from showing beside this tooltip. */}
    <InfoTrigger type="button" aria-label={label} title="" data-testid={testId}>
      <InfoOutlinedIcon fontSize="inherit" />
    </InfoTrigger>
  </Tooltip>
);
